import * as types from 'modules/selfServices/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

/** @type {import('modules/selfServices/types').SelfServiceTypeEnum} */
export const initialState = null;

/**
 * @param {import('modules/selfServices/types').SelfServiceTypeEnum} _
 * @param {import('modules/selfServices/types').OpenSendWizardAction} action
 */
const set = (_, { payload }) => payload.type;

const reset = () => initialState;

export default createReducer(initialState, {
  [types.OPEN_SEND_WIZARD]: set,
  [types.CLOSE_SEND_WIZARD]: reset,
});
